import { render, staticRenderFns } from "./publish.vue?vue&type=template&id=654b5d79&scoped=true"
import script from "./publish.vue?vue&type=script&lang=js"
export * from "./publish.vue?vue&type=script&lang=js"
import style0 from "./publish.vue?vue&type=style&index=0&id=654b5d79&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654b5d79",
  null
  
)

export default component.exports